export default {
    props: {
        messagesApply: {
            type: String,
            default: undefined,
            kComposite: 'messages.apply'
        }, 
        messagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.cancel'
        }, 
        messagesPreviewInput: {
            type: String,
            default: undefined,
            kComposite: 'messages.previewInput'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPicker/Messages.js